// defines position of the vertices
function positionBuffer (hoogte, dikte, degrees, degreesOther) {
  const radians = degrees*(Math.PI/180)
  const y = hoogte
  const z = dikte/2
  const b = y/Math.tan(radians)
  const radiansOther = degreesOther*(Math.PI/180)
  const bOther =  y/Math.tan(radiansOther)
  return [
    //front
    0, y, -z,
    bOther, 0, -z,
    -b, 0, -z,

    //back
    bOther, 0, z,
    0, y, z,
    -b, 0, z,

    //bottom
    -b, 0, -z,
    bOther, 0, -z,
    bOther, 0, z,

    bOther, 0, z,
    -b, 0, z,
    -b, 0, -z,

    //left
    bOther, 0, z,
    bOther, 0, -z,
    0, y, -z,

    bOther, 0, z,
    0, y, -z,
    0, y, z,

    //right
    0, y, -z,
    -b, 0, -z,
    -b, 0, z,

    0, y, z,
    0, y, -z,
    -b, 0, z,
  ]
}

// defines position of the textures
function uvBuffer (hoogte, dikte, degrees, degreesOther, maxTextureWith, maxTextureHeight) { 
  //return [0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0]
  //return [0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1,0]
  const radians = degrees*(Math.PI/180)
  const radiansOther = degreesOther*(Math.PI/180)
  
  const y = hoogte
  // const z = dikte/2
  const b = y/Math.tan(radians)
  const bOther =  y/Math.tan(radiansOther)
  
  const c = (bOther/maxTextureWith) * (1/(bOther/maxTextureWith)*Math.random())
  const d = c+(bOther)/maxTextureWith
  const e = c+(bOther+b)/maxTextureWith

  // const k = ((b+bOther)/maxTextureWith) * (1/((b+bOther)/maxTextureWith)*Math.random())
  // const l = k+(b+bOther)/maxTextureWith

  const o = (y/maxTextureWith) * (1/(y/maxTextureWith)*Math.random())
  const p = o+y/maxTextureWith

  const m = (y/maxTextureWith) * (1/(y/maxTextureWith)*Math.random())
  const n = m+y/maxTextureWith

  return [
    d, hoogte/maxTextureHeight+0.0025, 
    c, 0.0025,
    e, 0.0025, 

    c, 0.0025, 
    d, hoogte/maxTextureHeight+0.0025,
    e, 0.0025,

    // deze texture moet geflipt worden, want texture aan de onderkant komt niet overeen
    e, 0.0025, 
    c, 0.0025, 
    c, dikte/maxTextureHeight+0.0025,

    c, dikte/maxTextureHeight+0.0025, 
    e, dikte/maxTextureHeight+0.0025, 
    e, 0.0025,

    o, dikte/maxTextureHeight,
    o, 0, 
    p, 0,

    o, dikte/maxTextureHeight,
    p, 0,
    p, dikte/maxTextureHeight,

    m, 0, 
    n, 0, 
    n, dikte/maxTextureHeight,

    m, dikte/maxTextureHeight, 
    m, 0,
    n, dikte/maxTextureHeight,
  ]
}

// defines orientation of the faces (texture inside or outside)
function normalBuffer () {
  //return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
  //return [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,]
  //return [0,0,1]
  //return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
  return [
    0, 0, -1,
    0, 0, -1,
    0, 0, -1,

    0, 0, 1,
    0, 0, 1,
    0, 0, 1,

    0, -1, 0,
    0, -1, 0,
    0, -1, 0,
    0, -1, 0,
    0, -1, 0,
    0, -1, 0,

    1, 0, 0,
    1, 0, 0,
    1, 0, 0,
    1, 0, 0,
    1, 0, 0,
    1, 0, 0,

    -1, 0, 0,
    -1, 0, 0,
    -1, 0, 0,
    -1, 0, 0,
    -1, 0, 0,
    -1, 0, 0,
  ]
}

// group the vertices belonging to each of the 6 sides, allows for 6 different textures one for each side.
function groupBuffer () {
  return [
    {
      start: 0,
      count: 6,
      materialIndex: 0
    },
    {
      start: 6,
      count: 6,
      materialIndex: 1
    },
    {
      start: 12,
      count: 6,
      materialIndex: 2
    },
    {
      start: 18,
      count: 6,
      materialIndex: 3
    },
    {
      start: 24,
      count: 6,
      materialIndex: 4
    },
    {
      start: 30,
      count: 6,
      materialIndex: 5
    }
  ]
}

function groupBufferSelectFrame () {
  return [
    {
      start: 0,
      count: 3,
      materialIndex: 0
    },
    {
      start: 3,
      count: 3,
      materialIndex: 1
    },
    {
      start: 6,
      count: 6,
      materialIndex: 2
    },
    {
      start: 12,
      count: 6,
      materialIndex: 3
    },
    {
      start: 28,
      count: 6,
      materialIndex: 4
    }
  ]
}

export { positionBuffer, uvBuffer, normalBuffer, groupBuffer, groupBufferSelectFrame }